import React from 'react';
import { Grid, Form, RadioButton } from 'fw/forms';
import { Button } from 'fw/components';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Col, Row } from "react-bootstrap";
import * as Formatter from 'fw/components/formatter/Formatter';
import { Link } from 'react-router-dom';
import Spinner from 'layouts/public/spinner/Spinner'

class ExpiringMemberships extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
        return {
			loading: true,
			list: [],
			form: {
				expireMode: "EXPIRING"
			}
		};
    }

    componentDidMount() {
		this.search();
    }

	onChange = (form) => {
		this.setState({ form }, this.search);
	}
	
    onExportData = () => {
        const rq = {
            expireMode: this.state.form.expireMode
        };

        new API().post(APIModules.Admin.url('/sponsorDashboard/getExpiringMembershipsExport'), rq,
            {
                success: (sr) => {
                    new API().download(sr.data);
                }
            });
    }
    
	search = (opts, callback) => {
        const rq = Object.assign({}, this.state.form);

        new API().post(APIModules.Admin.url('/sponsorDashboard/getExpiringMemberships'), rq,
            {
                success: (r) => {
					var state = {
						loading: false,
						list: r.data.items,
						form: this.state.form
                    };
					
					// Store search results
                    this.setState(state);

                    // Callback
                    if (callback)
                        callback();
                }
			});
    }

	linkFormatter = (row) => {
		return <Link to={'/admin/sponsorSetup/' + row.value}>{row.value}</Link>
    };

	render() {
		if (this.state.loading)
			return <Spinner />

		const columns = [
			{ key: 'sponsorId', name: 'CM ID', width: 50, formatter: this.linkFormatter, getRowMetaData: (row) => row, sortable: false },
			{ key: 'name', name: 'Corporate Member Name', width: 200, sortable: false },
			{ key: 'location', name: 'Location', sortable: false },
			{ key: 'primaryContactName', name: 'Primary Contact', sortable: false },
			{ key: 'reminderSent', name: 'Reminder Sent', formatter: Formatter.ClientDate, sortable: false },
			{ key: 'expirationDate', name: 'Expiration Date', formatter: Formatter.Date, sortable: false }
		];

		return (
			<React.Fragment>
				<Row>
					<Col md={6}>
						<ContentHeader title={"Memberships  – "} description={"Expiring and Expired Memberships within the system"} >
						</ContentHeader>
					</Col>
					<Form
						values={this.state.form}
						onChange={this.onChange}>
						<Col md={2}>				
							<RadioButton
								name="expireMode"
								option="EXPIRING"
								label="Expiring within 90 days"
							/>
						</Col>
						<Col md={2}>
							<RadioButton
								name="expireMode"
								option="EXPIRED"
								label="Expired"
							/>
						</Col>
					</Form>	
				</Row>
				<Row>
				<Col md={12}>
					<ContentBody>
					<Grid
						columns={columns}
						items={this.state.list}
						height={200}
						rowKey="id"
						name="default" />
						<hr />
						<div className="btn-toolbar">
						{this.state.list &&
							<Button
								id="btnExportCsv"
								onClick={this.onExportData}
								className="btn btn-default pull-right" >
								<FontAwesomeIcon icon={faFileExport} /> Export CSV
							</Button>
						}
						</div>
					</ContentBody>
					</Col>
				</Row>
			</React.Fragment>
		)
	}
}

export default ExpiringMemberships;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminSponsorDashboard/expiringMemberships/ExpiringMemberships.js